<button
  class="d-block text-body mb-1 p-2 btn-hover rounded w-100"
  (click)="notificationClickHandler($event)">
  <h4 class="fs-6">
    <span>{{ notification.title }}</span>
  </h4>
  <p class="small mb-1">
    {{ body }}
  </p>
  <p class="small text-body-tertiary">
    {{ notification.lastUpdated }}
  </p>
</button>
